import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-dth',
  templateUrl: './download-dth.component.html',
  styleUrls: ['./download-dth.component.scss']
})
export class DownloadDthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
